export enum IOCState {
  CONNECTED = 'CONNECTED',
  CONNECTING = 'CONNECTING',
  DISCONNECTED = 'DISCONNECTED',
  CONNECTION_ERROR = 'CONNECTION_ERROR',
  RECONNECTING = 'RECONNECTING',
  RECONNECT_ERROR = 'RECONNECT_ERROR',
  AUTH_ERROR = 'AUTH_ERROR',
  SAME_ACCOUNT_ERROR = 'SAME_ACCOUNT_ERROR',
}
